export default __webpack_public_path__ + "static/media/imprimir.419451e9.svg";